import { LoginForm } from "./LoginForm"

const AdminLogin = () =>{
    return(
        <div className="bg-[#9F7E7E] h-[100vh] flex items-center justify-center">
        <LoginForm formHeading="Admin"/>
        </div>
    )
}

export default AdminLogin;